// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"eed2c9d6","513":"37e2b685","703":"4bd64546"}[chunkId] + ".chunk.js";
};